import {CargoType} from "../transportation/models/cargo";
import {OrderDetailModel} from "../transportation/models/order";
import {RelationType} from "../transportation/models/relation";
import {Utils} from "./utils";


export class OrderUtils {
    public static displayPinCode(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO:
                return true;
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
                return false;
            default:
                return true;
        }
    }

    public static displayBarCode(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.RAIL_DEPO_ROAD:
            case RelationType.ROAD_DEPO:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO_ROAD:
                return true;
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.RAIL_DEPO:
                return false;
            default:
                return true;
        }
    }

    public static displayLorryRegNo(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.ROAD_DEPO_FERRY:
                return true;
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return false;
            default:
                return true;
        }
    }

    public static displaySupplierLorryRegNo(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
                return true;
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return false;
            default:
                return false;
        }
    }

    public static displayRecipientLorryRegNo(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.RAIL_DEPO_ROAD:
                return true;
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
                return false;
            default:
                return false;
        }
    }

    public static displayTrailerRegNo(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return true;
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
                return false;
            default:
                return true;
        }
    }

    public static displaySecuringDeclaration(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.FERRY_DEPO:
                return true;
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD :
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO:
                return false;
            default:
                return true;
        }
    }

    public static displayRecipient(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return true;
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.RAIL_DEPO:
                return false;
            default:
                return true;
        }
    }

    // display packingQuantity, cbm, packingName and remarks
    public static displayCargoProperties(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.FERRY_DEPO:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return true;
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
                return false;
            default:
                return true;
        }
    }

    public static displayRecipientWagonRegNo(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.RAIL_DEPO_RAIL:
                return true;
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.RAIL_DEPO_ROAD:
            case RelationType.FERRY_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.ROAD_DEPO:
                return false;
            default:
                return false;
        }
    }

    public static displayWagonRegNo(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.FERRY_RAIL:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.RAIL_FERRY:
                return true;
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.RAIL_DEPO:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.FERRY_DEPO:
                return false;
            default:
                return true;
        }
    }

    public static displaySupplierWagonRegNo(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.RAIL_DEPO_ROAD:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO:
                return true;
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.ROAD_DEPO:
                return false;
            default:
                return false;
        }
    }

    public static displayAssignWagonNumbersButton(relationType: RelationType | "", order: OrderDetailModel): boolean {
        return this.displayWagonRegNo(relationType) && !order.wagonRegNo ||
            this.displaySupplierWagonRegNo(relationType) && !order.supplierWagonRegNo ||
            this.displayRecipientWagonRegNo(relationType) && !order.recipientWagonRegNo;
    }

    public static displayContainerProperties(relationType: RelationType | "", cargoType: CargoType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return cargoType === CargoType.NORMATIVE_CONTAINER || cargoType === CargoType.DANGEROUS_CONTAINER;
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
                return false;
            default:
                return true;
        }
    }

    public static displayTemperatures(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return true;
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
                return false;
            default:
                return true;
        }
    }

    public static displayVoyageSection(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
                return true;
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return false;
            default:
                return true;
        }
    }

    public static displayCostsSection(relationType: RelationType | ""): boolean {
        switch (relationType) {
            case RelationType.ROAD_DEPO_FERRY:
            case RelationType.FERRY_DEPO_ROAD:
            case RelationType.RAIL_DEPO_FERRY:
            case RelationType.FERRY_DEPO_RAIL:
            case RelationType.FERRY_DEPO:
            case RelationType.ROAD_DEPO_ROAD:
            case RelationType.ROAD_DEPO_RAIL:
            case RelationType.ROAD_DEPO:
            case RelationType.RAIL_DEPO:
            case RelationType.RAIL_DEPO_RAIL:
            case RelationType.RAIL_DEPO_ROAD:
                return true;
            case RelationType.RAIL_FERRY:
            case RelationType.FERRY_RAIL:
                return false;
            default:
                return true;
        }
    }

    public static calculatePaymentWaiver(parkingCost: string | undefined) {
        let value = null;

        if (!parkingCost) {
            value = undefined;
        } else {
            const parkingCostNumber = Number.parseInt(parkingCost);

            if (parkingCostNumber === 0) {
                value = true;
            } else if (parkingCostNumber > 0) {
                value = false;
            }
        }

        return Utils.renderBooleanYesNoValue(value, true);
    }
}